import { Link } from "react-router-dom";
import servicesData from "../../data/servicesData";

export default function Services() {
  // Home page par sirf 6 services dikhani hain
  const homeServices = servicesData.slice(0, 6);

  return (
    <section id="services" className="services">
      <div className="container">

        <header className="section-header">
          <h2>Our Services</h2>
          <p>
            We offer a diverse set of digital services tailored to accelerate
            your business growth.
          </p>
        </header>

        <div className="row gy-4">
          {homeServices.map((service, index) => (
            <div
              className="col-lg-4 col-md-6"
              key={service.id}
              data-aos="fade-up"
              data-aos-delay={200 + index * 100}
            >
              <div className={`service-box ${service.color}`}>
                <i className={`${service.icon} icon`} />
                <h3>{service.title}</h3>
                <p>{service.shortDesc}</p>
                <Link to={`/services/${service.slug}`} className="read-more">
                  <span>Read More</span>
                  <i className="bi bi-arrow-right" />
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* View All Services Button */}
        <div className="text-center mt-5" data-aos="fade-up">
          <Link
            to="/services"
            className="btn"
            style={{
              backgroundColor: "#007bff",
              color: "white",
              padding: "14px 40px",
              borderRadius: "50px",
              fontWeight: "600",
              fontSize: "15px",
              transition: "all 0.3s ease",
            }}
          >
            View All Services <i className="bi bi-arrow-right ms-2" />
          </Link>
        </div>

      </div>
    </section>
  );
}